// extracted by mini-css-extract-plugin
module.exports = {"root":"AddTileButton_root__2IeIj","rootSmall":"AddTileButton_rootSmall__Rz76w"};